// Order matters!
// Environment polyfill is required for ./configuration.js
import './delivery-interface/polyfills';
// Environment configuration is required for monitoring startup
import './delivery-interface/monitor'; // TODO [ende] remove after creating ende architectural components
import './delivery-interface/shell';